module.exports = __webpack_public_path__ + "img/ico_pizza_azul.2c71e484.svg";